import { BaseQueryParams } from "../baseQuery";

export const estimatorService = BaseQueryParams(
  "estimatorService",
).injectEndpoints({
  endpoints: (builder) => ({
    getEstimatorPreview: builder.mutation({
      query: (body) => ({
        url: `/estimation/preview`,
        method: "POST",
        body,
      }),
    }),

    singleEstimation: builder.mutation({
      query: (body) => ({
        url: `/estimation/calculation/new`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetEstimatorPreviewMutation, useSingleEstimationMutation } =
  estimatorService;
